import { CustomCollapseCard, Text } from '@src/components';
import { Radio } from 'antd';
import '@src/styles/cardOrder/payment-type.scss';
import { useMediaQuery } from '@src/hooks/useMediaQuery';
import { useDispatch, useSelector } from 'react-redux';
import { setPaymentType } from '@src/store/slice/mobilExpressSlice';
import { loadBalancesUpdate } from '@src/store/slice/balanceUploadSlice';
import { useEffect } from 'react';
import { getCustomerVouList } from '@src/store/slice/customerSlice';
import { handleAuthStatus, isCreditCardUser } from '@src/utils/utils';

const PaymentType = () => {
  const dispatch = useDispatch();
  const isMobil = useMediaQuery({ query: '(max-width: 991.98px)' });
  const { paymentType } = useSelector((state) => state?.mobilExpress);
  const { currentLoadBalance } = useSelector((state) => state?.balanceUpload);
  const { customerVou } = useSelector((state) => state?.customer);
  const { userAuthorizationStatus } = useSelector((state) => state?.user);
  const updateLoadBalance = async (e) => {
    const value = e.target.value;
    await dispatch(loadBalancesUpdate({ ...currentLoadBalance, paymentType: value === 1 ? 4 : 5 }));
    await dispatch(setPaymentType(value));
  };

  useEffect(() => {
    dispatch(
      getCustomerVouList({
        customerId: currentLoadBalance?.customerId,
        vouId: currentLoadBalance.vouId,
      }),
    );
  }, [currentLoadBalance?.customerId, currentLoadBalance.vouId, dispatch]);

  useEffect(() => {
    if (!customerVou?.customerId) return;
    if (
      !isCreditCardUser(customerVou) ||
      handleAuthStatus(userAuthorizationStatus || [], 'ApprovalAuthorizationGroup') ||
      handleAuthStatus(userAuthorizationStatus || [], 'PaymentAuthorizationGroup')
    ) {
      return;
    }
    (async () => {
      if (customerVou?.pamId === 4 && customerVou?.patId === 2) {
        await dispatch(setPaymentType(1));
        await dispatch(loadBalancesUpdate({ ...currentLoadBalance, paymentType: 4 }));
      } else {
        await dispatch(setPaymentType(2));
        await dispatch(loadBalancesUpdate({ ...currentLoadBalance, paymentType: 5 }));
      }
    })();
  }, [customerVou, dispatch]);

  useEffect(() => {
    if (customerVou?.pamId === 4) {
      dispatch(setPaymentType(1));
    }
  }, [customerVou]);

  return (
    <CustomCollapseCard
      bodyCenter={!isMobil}
      cardTitle={<Text t="paymentTypeTitle" />}
      cardTitleAlign="center"
    >
      <Radio.Group
        id="ticketRestaurant-balanceUpload-payment-paymentType-custom-radioGroup-input-content"
        onChange={updateLoadBalance}
        value={paymentType}
        className="custom-radio-input-content"
      >
        {customerVou?.pamId === 4 && (
          <Radio
            id="ticketRestaurant-balanceUpload-payment-paymentType-custom-radio-input-content1"
            value={1}
            className={paymentType === 2 ? 'ant-radio-wrapper-unchecked' : null}
          >
            <div className="credit-card-title">
              <Text t="creditcard" />
            </div>
          </Radio>
        )}
        <Radio
          id="ticketRestaurant-balanceUpload-payment-paymentType-custom-radio-input-content2"
          value={2}
          className={paymentType === 1 ? 'ant-radio-wrapper-unchecked' : null}
        >
          <div className="eftTransfer-card-title">
            <Text t="eftTransfer" />
          </div>
        </Radio>
      </Radio.Group>
    </CustomCollapseCard>
  );
};

export default PaymentType;
